import { render, staticRenderFns } from "./AssistiveGradingTest.vue?vue&type=template&id=7d870739&scoped=true&"
import script from "./AssistiveGradingTest.vue?vue&type=script&lang=ts&"
export * from "./AssistiveGradingTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d870739",
  null
  
)

export default component.exports